import { useAppSelector } from 'app/hooks';
import { memo } from 'react';
import { Droppable } from 'react-beautiful-dnd';
import GenreRow from '../GenreRow';
import { getListStyle } from '../MenuBookEditorModal';
import SubGenreRowList from '../SubGenreRowList';

export interface GenreRowListProps {
  menuBookId?: number;
  onSelectedRowChanged: () => void;
}

function GenreRowList({ menuBookId, onSelectedRowChanged }: GenreRowListProps) {
  const genreIds = useAppSelector((state) => state.menuBookEditor.data.map((genre) => genre.id));

  return (
    <Droppable droppableId="root" type="genre">
      {(provided, snapshot) => (
        <div {...provided.droppableProps} ref={provided.innerRef} style={getListStyle(snapshot.isDraggingOver)}>
          {genreIds.map((genreId, index) => (
            <GenreRow
              key={`genre-${genreId}`}
              menuBookId={menuBookId}
              genreId={genreId}
              index={index}
              onSelectedRowChanged={onSelectedRowChanged}
            >
              <SubGenreRowList genreId={genreId} onSelectedRowChanged={onSelectedRowChanged} />
            </GenreRow>
          ))}
          {provided.placeholder}
        </div>
      )}
    </Droppable>
  );
}

export default memo(GenreRowList);
